let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1Xl7E")).then(() => parcelRequire('1eYnA'));